module.exports = __webpack_public_path__ + "static/media/boomwriter_reversed.a2a4dd98.png";